<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="page-user-list">
		<slot></slot>
		<div :class="customConfig.showPopup ? 'p-6' : 'vx-card p-6'">
			<div class="flex flex-wrap items-center justify-end" v-if="customConfig.tableOptions">
				<!-- ITEMS PER PAGE -->
				<div v-if="customConfig.showItemsPerPage" class="flex-grow">
					<vs-dropdown vs-trigger-click class="cursor-pointer">
						<div
							class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
						>
							<span class="mr-2"
								>{{
									paginationPageSize === 0
										? 0
										: currentPage * paginationPageSize - (paginationPageSize - 1)
								}}
								-
								{{
									optimizerManagerData.length - currentPage * paginationPageSize > 0
										? currentPage * paginationPageSize
										: optimizerManagerData.length
								}}
								{{ $t("Of") }} {{ pagination.total_records }}</span
							>
							<feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
						</div>
						<vs-dropdown-menu>
							<vs-dropdown-item @click="paginationSetPageSize(20)">
								<span>20</span>
							</vs-dropdown-item>
							<vs-dropdown-item @click="paginationSetPageSize(50)">
								<span>50</span>
							</vs-dropdown-item>
							<vs-dropdown-item @click="paginationSetPageSize(100)">
								<span>100</span>
							</vs-dropdown-item>
							<vs-dropdown-item @click="paginationSetPageSize(200)">
								<span>200</span>
							</vs-dropdown-item>
						</vs-dropdown-menu>
					</vs-dropdown>
				</div>
				<template>
					<!-- ITEMS PER PAGE -->
					<vs-dropdown vs-trigger-click class="cursor-pointer">
						<div
							class="p-3 mt-1 mr-2 border border-solid d-theme-border-grey-light rounded-lg d-theme-dark-bg cursor-pointer font-medium"
						>
							<span class="mr-2">{{ $t("SearchBy") }} {{ searchSelected }}</span>
							<feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
						</div>
						<vs-dropdown-menu>
							<vs-dropdown-item @click="setSearchField('Id')">
								<span>{{ "Id" }}</span>
							</vs-dropdown-item>
							<vs-dropdown-item @click="setSearchField('Optimizer')">
								<span>{{ $t("Routing.Optimizer") }}</span>
							</vs-dropdown-item>
							<vs-dropdown-item @click="setSearchField('Company')">
								<span>{{ $t("Company") }}</span>
							</vs-dropdown-item>
						</vs-dropdown-menu>
					</vs-dropdown>
				</template>
				<div
					class="vx-col md:w-1/3 sm:w-1/2 w-full p-0"
					v-if="searchField === 'Company' || searchField === 'Optimizer'"
				>
					<div class="vx-row">
						<div class="vx-col w-full">
							<v-select
								v-model="dataSelected"
								class="w-full"
								multiple
								:clearable="false"
								:options="searchList"
								:dir="$vs.rtl ? 'rtl' : 'ltr'"
								:placeholder="$t('Select')"
							>
								<template v-slot:no-options="{search, searching}">
									<template v-if="searching">
										{{ $t("NoResultsFoundFor") + " " }}<em>{{ search }}</em>
									</template>
									<template v-else>
										{{ $t("NoResultsFound") }}
									</template>
								</template>
							</v-select>
						</div>
					</div>
				</div>
				<!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
				<div v-else class="vx-col md:w-1/3 sm:w-1/2 w-full p-0">
					<vx-tooltip
						class="cursor-pointer"
						color="primary"
						position="bottom"
						delay=".1s"
						:title="$t('Search')"
						:text="$t('SearchSeparatedByCommas') + '.'"
					>
						<tags-input
							element-id="tags"
							v-model="searchQuery"
							add-tags-on-comma
							add-tags-on-blur
							:placeholder="$t('Teams.Form.Add') + ' ' + searchSelected"
							:typeahead="true"
							@keyup.enter="searchOptimizerManager"
						></tags-input>
					</vx-tooltip>
				</div>
				<vs-button
					class="ml-2"
					color="primary"
					icon-pack="feather"
					icon="icon-search"
					:title="$t('VisitPoints.Search')"
					@click.prevent="searchOptimizerManager"
				></vs-button>
				<vs-button
					class="ml-2"
					color="primary"
					icon-pack="feather"
					icon="icon-refresh-cw"
					:title="$t('Refresh')"
					@click.prevent="refreshOptimizerManager()"
				></vs-button>
				<vs-button
					class="ml-2"
					color="primary"
					icon-pack="feather"
					icon="icon-plus"
					:title="$t('Add') + ' ' + $t('Setting.Setting')"
					@click.prevent="$router.push('/apps/optimizer-manager/create')"
				></vs-button>
			</div>
			<!-- AgGrid Table -->
			<ag-grid-vue
				ref="agGridTable"
				:components="components"
				:gridOptions="gridOptions"
				:style="!customConfig.tableOptions ? 'padding-top: 80px' : ''"
				class="ag-theme-material w-100 my-4 ag-grid-table"
				:class="[{'ag-customizer-container': !isWidthPortatil}]"
				:columnDefs="columnDefs"
				:defaultColDef="defaultColDef"
				:rowData="optimizerManagerData"
				:rowSelection="customConfig.rowSelection"
				colResizeDefault="shift"
				:animateRows="true"
				:pagination="true"
				:paginationPageSize="paginationPageSize"
				:suppressPaginationPanel="true"
				:enableRtl="$vs.rtl"
				:overlayNoRowsTemplate="overlayNoRowsTemplate"
				:overlayLoadingTemplate="overlayLoadingTemplate"
				:enableCellTextSelection="true"
			>
			</ag-grid-vue>
			<vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
		</div>
	</div>
</template>

<script>
import {optimizerManagerListMixin} from "../model/OptimizerManagerListMixin.js";

export default {
	mixins: [optimizerManagerListMixin],
};
</script>

<style lang="scss" scoped>
#page-user-list {
	.user-list-filters {
		.vs__actions {
			position: absolute;
			right: 0;
			top: 50%;
			transform: translateY(-58%);
		}
	}
}
</style>
